// App.js
import React from 'react';
import './App.css';

function App() {
  return (
    <div className="not-found-container">
      <div className="stars">
        {[...Array(100)].map((_, i) => (
          <div key={i} className="star" style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`
          }}></div>
        ))}
      </div>
      
      <div className="content">
        <div className="error-code">
          <span className="digit">4</span>
          <div className="planet">
            <div className="crater"></div>
            <div className="crater"></div>
            <div className="crater"></div>
          </div>
          <span className="digit">4</span>
        </div>
        
        <h1 className="title">Page Not Found</h1>
        <p className="message">
          Oops! The page you're looking for seems to have drifted off into space.
          It might have been moved, deleted, or perhaps it never existed.
        </p>
      </div>
    </div>
  );
}

export default App;